import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/CartScreen.css";


function CartScreen() {

  const navigate = useNavigate();

  const {
    restaurantId,
    tableId,
  } = useParams();

  const {
    cart,
    cartCount,
    cartTotal,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    clearCart,
  } = useCart();


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  const handleBackToMenu = () => {

    navigate(homePath);

    setTimeout(() => {

      const menuSection =
        document.querySelector(".t6-menu-section");

      if (menuSection) {

        menuSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

    }, 500);

  };


  const handleContinueOrder = () => {

    if (!cart || cart.length === 0) {
      return;
    }

    navigate(`${homePath}/checkout`);

  };


  return (

    <div className="t6-cart-page">

      {/* HEADER */}

      <section className="t6-cart-hero">

        <div className="t6-cart-hero-inner">

          <button
            type="button"
            className="t6-cart-back"
            onClick={handleBackToMenu}
          >
            ← Back to menu
          </button>

          <span className="t6-cart-eyebrow">
            YOUR ORDER
          </span>

          <h1>
            Your Table Order
          </h1>

          <p>
            Freshly prepared for your table at Kavos Taverna.
          </p>

        </div>

      </section>


      {/* CART */}

      <main className="t6-cart-container">

        {cart && cart.length > 0 ? (

          <>

            <div className="t6-cart-top">

              <div>

                <span className="t6-cart-label">
                  TABLE {tableId}
                </span>

                <h2>
                  {cartCount}{" "}
                  {cartCount === 1 ? "item" : "items"}
                </h2>

              </div>

              <button
                type="button"
                className="t6-clear-cart"
                onClick={clearCart}
              >
                Clear order
              </button>

            </div>


            <div className="t6-cart-layout">

              {/* ITEMS */}

              <div className="t6-cart-items">

                {cart.map((item) => (

                  <article
                    className="t6-cart-item"
                    key={item.id}
                  >

                    <div className="t6-cart-item-image">

                      {item.image ? (

                        <img
                          src={item.image}
                          alt={item.name}
                        />

                      ) : (

                        <div className="t6-cart-placeholder">
                          K
                        </div>

                      )}

                    </div>


                    <div className="t6-cart-item-info">

                      <h3>
                        {item.name}
                      </h3>

                      {item.description && (

                        <p>
                          {item.description}
                        </p>

                      )}

                      <span className="t6-cart-item-price">
                        ₹{Number(item.price).toFixed(2)}
                      </span>

                    </div>


                    <div className="t6-cart-item-actions">

                      <div className="t6-quantity-control">

                        <button
                          type="button"
                          onClick={() =>
                            decreaseQuantity(item.id)
                          }
                        >
                          −
                        </button>

                        <span>
                          {item.quantity}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            increaseQuantity(item.id)
                          }
                        >
                          +
                        </button>

                      </div>


                      <strong className="t6-item-total">

                        ₹
                        {(
                          Number(item.price) *
                          Number(item.quantity)
                        ).toFixed(2)}

                      </strong>


                      <button
                        type="button"
                        className="t6-remove-item"
                        onClick={() =>
                          removeFromCart(item.id)
                        }
                      >
                        Remove
                      </button>

                    </div>

                  </article>

                ))}

              </div>


              {/* SUMMARY */}

              <aside className="t6-cart-summary">

                <span className="t6-summary-eyebrow">
                  ORDER SUMMARY
                </span>

                <h2>
                  Your order
                </h2>


                <div className="t6-summary-line">

                  <span>
                    Items
                  </span>

                  <span>
                    {cartCount}
                  </span>

                </div>


                <div className="t6-summary-line">

                  <span>
                    Subtotal
                  </span>

                  <span>
                    ₹{Number(cartTotal).toFixed(2)}
                  </span>

                </div>


                <div className="t6-summary-divider" />


                <div className="t6-summary-total">

                  <span>
                    Total
                  </span>

                  <strong>
                    ₹{Number(cartTotal).toFixed(2)}
                  </strong>

                </div>


                <button
                  type="button"
                  className="t6-continue-button"
                  onClick={handleContinueOrder}
                >
                  Continue Order
                  <span>→</span>
                </button>


                <button
                  type="button"
                  className="t6-summary-menu-button"
                  onClick={handleBackToMenu}
                >
                  Add more items
                </button>


                <p className="t6-cart-note">
                  Taxes and service charges will be
                  calculated at checkout.
                </p>

              </aside>

            </div>

          </>

        ) : (

          /* EMPTY CART */

          <div className="t6-empty-cart">

            <div className="t6-empty-icon">
              🛒
            </div>

            <span className="t6-cart-eyebrow">
              YOUR ORDER
            </span>

            <h2>
              Your table is waiting
            </h2>

            <p>
              Your cart is currently empty.
              Explore our Mediterranean menu and
              choose something delicious.
            </p>

            <button
              type="button"
              className="t6-empty-menu-button"
              onClick={handleBackToMenu}
            >
              Explore the menu
              <span>→</span>
            </button>

          </div>

        )}

      </main>

    </div>
  );
}


export default CartScreen;